module.exports = __webpack_public_path__ + "static/media/frameCard.dd5def63.png";